(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cb-header"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('keydown',event=>{if(event.key==='Escape')document.querySelectorAll('.cb-header details[open]').forEach(details=>{details.open=false;details.querySelector('summary')?.focus()})});
document.addEventListener('click',event=>{document.querySelectorAll('.cb-header details[open]').forEach(details=>{if(!details.contains(event.target))details.open=false})});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-models"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cb-model-finder')){
class CBModelFinder extends HTMLElement{
  connectedCallback(){
    if(this.ready)return;this.ready=true;
    this.strings=JSON.parse(this.querySelector('[data-model-strings]').textContent);
    this.select=this.querySelector('[name=model]');this.status=this.querySelector('[role=status]');
    this.brandButtons=[...this.querySelectorAll('[data-brand]')];this.activeBrand='all';
    this.catalog=this.dataset.catalog==='true';this.root=this.dataset.root||'/';
    this.norm=v=>String(v||'').toLowerCase().replace(/\s+/g,' ').trim();
    this.slug=v=>this.norm(v).replace(/[^a-z0-9]+/g,'-');
    this.brand=v=>{const value=String(v||'').trim();if(/^iphone\b/i.test(value))return'iphone';if(/^(samsung(?:\s+galaxy)?|galaxy)\b/i.test(value))return'samsung';return''};
    this.canonical=(v,brand)=>{let value=this.norm(v);if(brand==='samsung')value=value.replace(/^galaxy\s+/,'samsung ').replace(/^samsung galaxy\s+/,'samsung ');return value};
    this.label=(v,brand)=>{const names={iphone:'iPhone',samsung:'Samsung',galaxy:'Galaxy',pro:'Pro',max:'Max',plus:'Plus',mini:'Mini',air:'Air',xs:'XS',xr:'XR',x:'X',se:'SE',ultra:'Ultra',edge:'Edge',fe:'FE',fold:'Fold',flip:'Flip'};let label=this.canonical(v,brand).split(' ').map(word=>names[word]||(/^[a-z]\d+(?:\+)?$/i.test(word)?word.toUpperCase():word.charAt(0).toUpperCase()+word.slice(1))).join(' ');if(brand==='samsung')label=label.replace(/^Samsung\s*/,'Samsung Galaxy ');return label};
    this.querySelector('form').addEventListener('submit',e=>{e.preventDefault();this.go(this.select.value)});
    this.brandButtons.forEach(button=>button.addEventListener('click',()=>this.setBrand(button.dataset.brand)));
    this.querySelector('[data-instock]')?.addEventListener('change',()=>this.render());
    this.querySelector('[data-sort]')?.addEventListener('change',()=>this.render());
    this.onPop=()=>this.restoreFromUrl();
    if(this.catalog)window.addEventListener('popstate',this.onPop);
    this.load();
  }
  disconnectedCallback(){window.removeEventListener('popstate',this.onPop)}
  async load(){
    try{
      if(!window.cbPhoneCatalog){window.cbPhoneCatalog=(async()=>{
        let url=this.root+'collections/all?view=cb-model-data',products=[],seen=new Set();
        while(url){const u=new URL(url,location.origin);if(u.origin!==location.origin||seen.has(u.href))throw Error('Invalid catalog page');seen.add(u.href);u.searchParams.set('view','cb-model-data');const res=await fetch(u.pathname+u.search,{credentials:'same-origin'});if(!res.ok)throw Error('Catalog unavailable');const data=JSON.parse(await res.text());products.push(...data.products);url=data.next;}
        return products;
      })().catch(e=>{window.cbPhoneCatalog=null;throw e})}
      this.products=await window.cbPhoneCatalog;
      this.models=new Map();
      this.products.forEach(p=>{p.matches=new Map();p.ids.forEach((id,i)=>{
        const variantModels=new Map();
        [p.one[i],p.two[i],p.three[i]].forEach(v=>{const brand=this.brand(v);if(!brand)return;const value=this.canonical(v,brand);variantModels.set(this.slug(value),{value,brand})});
        variantModels.forEach(({value,brand},key)=>{
          if(!p.matches.has(key))p.matches.set(key,[]);p.matches.get(key).push(i);
          if(!this.models.has(key))this.models.set(key,{label:this.label(value,brand),brand,products:new Set(),stock:new Set()});
          this.models.get(key).products.add(p.url);if(p.available[i])this.models.get(key).stock.add(p.url);
        });
      })});
      const weight=v=>{const n=parseInt(v.match(/\d+/)?.[0]||'0',10);return n*10+(v.includes('pro-max')?4:v.includes('pro')?3:v.includes('plus')?2:1)};
      this.sorted=[...this.models].sort((a,b)=>a[1].brand.localeCompare(b[1].brand)||weight(b[0])-weight(a[0])||a[0].localeCompare(b[0]));
      this.brandButtons.forEach(button=>button.disabled=false);
      this.select.disabled=false;this.querySelector('button[type=submit]').disabled=false;
      this.restoreFromUrl(false);
      if(this.catalog){this.querySelector('.cb-model-tools').hidden=false;this.render()}
      else this.status.textContent=this.strings.choose;
    }catch(e){this.status.textContent=this.strings.error;const a=document.createElement('a');a.href=this.root+'collections/all';a.textContent=' '+this.strings.all;this.status.append(a)}
  }
  availableModels(brand=this.activeBrand){return this.sorted.filter(([,m])=>m.stock.size>0&&(brand==='all'||m.brand===brand))}
  updateBrandButtons(){this.brandButtons.forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.brand===this.activeBrand)))}
  populateSelect(requested=''){
    this.select.replaceChildren(new Option(this.strings.all,''));
    const brands=this.activeBrand==='all'?['iphone','samsung']:[this.activeBrand];
    brands.forEach(brand=>{const models=this.availableModels(brand);if(!models.length)return;const group=document.createElement('optgroup');group.label=brand==='iphone'?this.strings.apple:this.strings.samsung;models.forEach(([key,m])=>group.append(new Option(m.label+' · '+m.stock.size+' '+this.strings.styles,key)));this.select.append(group)});
    if(requested&&this.models.get(requested)?.stock.size>0&&(this.activeBrand==='all'||this.models.get(requested).brand===this.activeBrand))this.select.value=requested;
  }
  renderTiles(){
    const limit=this.catalog?6:8,available=this.availableModels('all');let choices=[];
    if(this.activeBrand==='all'){
      const quota=Math.floor(limit/2);choices.push(...available.filter(([,m])=>m.brand==='iphone').slice(0,quota),...available.filter(([,m])=>m.brand==='samsung').slice(0,quota));
      const picked=new Set(choices.map(([key])=>key));choices.push(...available.filter(([key])=>!picked.has(key)).slice(0,limit-choices.length));
    }else choices=this.availableModels(this.activeBrand).slice(0,limit);
    const tiles=this.querySelector('[data-model-tiles]');tiles.replaceChildren();
    choices.slice(0,limit).forEach(([key,m])=>{
      const a=document.createElement('a');a.className='cb-model-tile';a.href=this.pathFor(key);
      const icon=document.createElement('span');icon.className='cb-phone-icon';icon.setAttribute('aria-hidden','true');
      const name=document.createElement('strong');name.textContent=m.label;
      const count=document.createElement('small');count.textContent=m.stock.size+' '+this.strings.available;
      a.append(icon,name,count);a.addEventListener('click',e=>{if(this.catalog&&!e.ctrlKey&&!e.metaKey&&!e.shiftKey){e.preventDefault();this.activeBrand=m.brand;this.updateBrandButtons();this.populateSelect(key);this.renderTiles();this.go(key)}});tiles.append(a);
    });
  }
  setBrand(brand,push=true){
    this.activeBrand=['iphone','samsung'].includes(brand)?brand:'all';this.updateBrandButtons();this.populateSelect();this.renderTiles();
    if(this.catalog){if(push)history.pushState({},'',this.pathFor(''));this.render()}else this.status.textContent=this.strings.choose;
  }
  restoreFromUrl(render=true){
    if(!this.models)return;const params=new URL(location.href).searchParams,requested=params.get('model')||'',requestedModel=this.models.get(requested),urlBrand=params.get('brand');
    this.activeBrand=['iphone','samsung'].includes(urlBrand)?urlBrand:(requestedModel?.brand||'all');
    if(requestedModel&&this.activeBrand!==requestedModel.brand)this.activeBrand=requestedModel.brand;
    this.updateBrandButtons();this.populateSelect(requested);this.renderTiles();if(render&&this.catalog)this.render();
  }
  pathFor(key){
    const params=new URLSearchParams({view:'cb-models'}),brand=key?(this.models.get(key)?.brand||this.activeBrand):this.activeBrand;
    if(brand&&brand!=='all')params.set('brand',brand);if(key)params.set('model',key);return this.root+'collections/all?'+params.toString();
  }
  go(key){
    const path=this.pathFor(key);
    if(!this.catalog){location.assign(path);return}
    history.pushState({},'',path);this.render();
  }
  render(){
    const key=this.select.value,onlyStock=this.querySelector('[data-instock]').checked;
    const rows=[];
    this.products.forEach(p=>{let indexes;if(key)indexes=p.matches.get(key)||[];else{const entries=[...p.matches].filter(([modelKey])=>this.activeBrand==='all'||this.models.get(modelKey)?.brand===this.activeBrand);indexes=[...new Set(entries.flatMap(([,variantIndexes])=>variantIndexes))]}if(onlyStock)indexes=indexes.filter(i=>p.available[i]);if(!indexes.length)return;const best=indexes.find(i=>p.available[i])??indexes[0];rows.push({p,i:best,price:p.prices[best],available:p.available[best]})});
    const sort=this.querySelector('[data-sort]').value;rows.sort((a,b)=>sort==='low'?a.price-b.price:sort==='high'?b.price-a.price:a.p.title.localeCompare(b.p.title));
    const target=this.querySelector('[data-results]');target.replaceChildren();
    const money=new Intl.NumberFormat('en-PK',{style:'currency',currency:this.dataset.currency||'PKR',maximumFractionDigits:0});
    rows.forEach(({p,i,price,available})=>{
      const card=document.createElement('article');card.className='cb-case-card';
      const link=document.createElement('a');const url=new URL(p.url,location.origin);url.searchParams.set('variant',String(p.ids[i]));link.href=url.pathname+url.search;
      const photo=document.createElement('img');photo.src=p.image;photo.alt=p.title;photo.loading='lazy';photo.width=700;photo.height=700;
      const name=document.createElement('h2');name.textContent=p.title;
      const model=document.createElement('p');model.className='cb-case-model';model.textContent=key?this.models.get(key).label:(this.activeBrand==='iphone'?this.strings.apple:this.activeBrand==='samsung'?this.strings.samsung:this.strings.all_brands);
      const cost=document.createElement('p');cost.className='cb-case-price';cost.textContent=money.format(price/100);
      const action=document.createElement('span');action.className='cb-case-action';action.textContent=(available?this.strings.count:this.strings.sold)+' ↗';
      link.append(photo,model,name,cost,action);card.append(link);target.append(card);
    });
    const context=key?this.models.get(key).label:(this.activeBrand==='iphone'?this.strings.apple:this.activeBrand==='samsung'?this.strings.samsung:'');
    this.status.textContent=rows.length?(rows.length+' '+this.strings.styles+(context?' · '+context:'')):this.strings.empty;
    this.querySelectorAll('.cb-model-tile').forEach(a=>a.setAttribute('aria-current',new URL(a.href).searchParams.get('model')===key?'true':'false'));
  }
}
customElements.define('cb-model-finder',CBModelFinder);
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cb-sticker-tools"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('cb-sticker-search')){
  customElements.define('cb-sticker-search',class extends HTMLElement{
    connectedCallback(){
      if(this.dataset.ready)return;
      this.dataset.ready='true';
      document.documentElement.classList.add('cb-has-sticker-tools');
      this.input=this.querySelector('input[type="search"]');
      this.clear=this.querySelector('.cb-sticker-searchbox__clear');
      this.status=this.querySelector('.cb-sticker-search-status');
      this.results=this.querySelector('.cb-sticker-results');
      this.timer=null;
      this.productsPromise=null;
      this.input.addEventListener('input',()=>{
        clearTimeout(this.timer);
        this.clear.hidden=!this.input.value;
        this.timer=setTimeout(()=>this.search(),140);
      });
      this.clear.addEventListener('click',()=>this.reset(true));
      document.addEventListener('keydown',event=>{
        if((event.metaKey||event.ctrlKey)&&event.key.toLowerCase()==='k'){
          event.preventDefault();this.input.focus();
        }
      });
    }

    nativeContainer(){
      return document.getElementById('ProductGridContainer')||document.getElementById('product-grid')?.parentElement;
    }

    setSearching(active){
      this.classList.toggle('is-searching',active);
      this.results.hidden=!active;
      this.nativeContainer()?.classList.toggle('cb-sticker-native-hidden',active);
    }

    reset(focus){
      this.input.value='';
      this.clear.hidden=true;
      this.status.textContent='';
      this.results.replaceChildren();
      this.setSearching(false);
      if(focus)this.input.focus();
    }

    async products(){
      if(!this.productsPromise){
        this.productsPromise=fetch(this.dataset.source).then(response=>{
          if(!response.ok)throw new Error(`Search data ${response.status}`);
          return response.json();
        }).then(data=>Array.isArray(data.products)?data.products:[]).catch(error=>{
          this.productsPromise=null;throw error;
        });
      }
      return this.productsPromise;
    }

    normalize(value){
      return value.toLocaleLowerCase().normalize('NFKD').replace(/[\u0300-\u036f]/g,'').trim();
    }

    async search(){
      const query=this.normalize(this.input.value);
      if(!query){this.reset(false);return;}
      this.setSearching(true);
      this.status.textContent=this.dataset.loading;
      this.results.replaceChildren();
      try{
        const products=await this.products();
        if(query!==this.normalize(this.input.value))return;
        const terms=query.split(/\s+/).filter(Boolean);
        const matches=products.filter(product=>{
          const haystack=this.normalize(`${product.title} ${product.variant_title||''}`);
          return terms.every(term=>haystack.includes(term));
        });
        this.render(matches);
      }catch(error){
        this.status.textContent=this.dataset.error;
      }
    }

    render(products){
      this.results.replaceChildren();
      if(!products.length){this.status.textContent=this.dataset.empty;return;}
      this.status.textContent=`${products.length} ${products.length===1?this.dataset.result:this.dataset.results}`;
      const fragment=document.createDocumentFragment();
      products.forEach(product=>fragment.append(this.card(product)));
      this.results.append(fragment);
    }

    card(product){
      const item=document.createElement('li');
      item.className='cb-sticker-result';
      const article=document.createElement('article');
      const media=document.createElement('a');
      media.className='cb-sticker-result__media';media.href=product.url;
      if(product.image){
        const image=document.createElement('img');
        image.src=product.image;image.alt=product.title;image.loading='lazy';image.width=700;image.height=700;
        media.append(image);
      }
      const details=document.createElement('div');details.className='cb-sticker-result__details';
      const title=document.createElement('a');title.className='cb-sticker-result__title';title.href=product.url;title.textContent=product.title;
      const prices=document.createElement('div');prices.className='cb-sticker-result__price';
      if(product.on_sale&&product.compare_at_price){const compare=document.createElement('s');compare.textContent=product.compare_at_price;prices.append(compare);}
      const price=document.createElement('strong');price.textContent=product.price;prices.append(price);
      const add=document.createElement('button');add.type='button';add.className='cb-sticker-result__add';
      add.textContent=product.available?'+':'×';add.disabled=!product.available;
      add.setAttribute('aria-label',product.available?`${this.dataset.addLabel}: ${product.title}`:`${this.dataset.soldOut}: ${product.title}`);
      if(product.available)add.addEventListener('click',()=>this.add(product,add));
      details.append(title,prices,add);article.append(media,details);item.append(article);return item;
    }

    async add(product,button){
      button.disabled=true;button.setAttribute('aria-busy','true');
      try{
        const response=await fetch(`${this.dataset.cartAdd}.js`,{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id:Number(product.variant_id),quantity:1}]})});
        if(!response.ok)throw new Error(`Cart ${response.status}`);
        const cartResponse=await fetch(`${this.dataset.cartUrl}.js`,{headers:{Accept:'application/json'}});
        if(!cartResponse.ok)throw new Error(`Cart state ${cartResponse.status}`);
        const cart=await cartResponse.json();
        document.querySelectorAll('.cart-count-bubble span[aria-hidden="true"]').forEach(count=>{count.textContent=cart.item_count});
        button.textContent='✓';
        this.status.textContent=`${product.title} — ${this.dataset.added}`;
        setTimeout(()=>{button.textContent='+';button.disabled=false;button.removeAttribute('aria-busy')},1300);
      }catch(error){
        button.textContent='!';button.disabled=false;button.removeAttribute('aria-busy');this.status.textContent=this.dataset.error;
        setTimeout(()=>{button.textContent='+'},1300);
      }
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["metal-sticker-video-slider"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-metal-video-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-metal-video-track]');
    const previous = slider.querySelector('[data-metal-video-previous]');
    const next = slider.querySelector('[data-metal-video-next]');
    if (!track || !previous || !next) return;

    const move = (direction) => {
      const card = track.querySelector('.metal-video__card');
      const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
      track.scrollBy({ left: direction * ((card?.offsetWidth || track.clientWidth) + gap), behavior: 'smooth' });
    };

    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
  });

  } catch(e) { console.error(e); }
})();
})();
